<div class="home-filter-shell" :style="branding_style">
  <HomeNavBar @active-profile-loaded="set_active_profile" />
  <InactivityModal />

  <div class="container-fluid bg-white pb-extra">
    <div class="row p-2 g-3">
      <div class="home-filter-identity">
        <div class="home-filter-logo">
          <img v-if="get_company_logo()" :src="get_company_logo()" :alt="company?.company_name || 'Organisation'" />

          <div v-else class="home-filter-logo-fallback">
            {{ (company?.company_name || "?").charAt(0).toUpperCase() }}
          </div>
        </div>
        <div>
          <p class="home-filter-eyebrow">{{ get_company_type() }}</p>
          <h4 class="fw-bold">{{ company?.company_name || 'Loading...' }}</h4>
          <p class="home-filter-summary">
            {{ company_description || 'No description available yet.' }}
          </p>
        </div>
      </div>


      <div class="col-12 col-lg-4">
        <div class="home-filter-panel home-filter-setup h-100">
          <div class="d-flex justify-content-between align-items-start gap-3 mb-3">
            <div>
              <h2>Profile Setup</h2>
              <p>Complete these details so people can recognize and contact your organisation.</p>
            </div>
            <strong>{{ profile_completion }}%</strong>
          </div>

          <div class="progress rounded-5 mb-4">
            <div class="progress-bar" role="progressbar" :style="{ width: profile_completion + '%' }"
              :aria-valuenow="profile_completion" aria-valuemin="0" aria-valuemax="100"></div>
          </div>

          <div class="home-filter-checklist">
            <div v-for="item in setup_items" :key="item.label" class="home-filter-check">
              <i :class="item.done ? 'bi bi-check-circle-fill text-success' : 'bi bi-circle text-muted'"></i>
              <span>{{ item.label }}</span>
            </div>
          </div>

          <button class="btn btn-primary rounded mt-4 text-xs" @click="go_to_organization_profile">
            Continue Setup
          </button>
        </div>
      </div>

      <div class="col-12 col-lg-8">
        <div class="home-filter-panel h-100">
          <div class="home-filter-section-header">
            <div>
              <h2>Quick Actions</h2>
              <p>Choose what you want to do next.</p>
            </div>
          </div>

          <div class="home-filter-actions">
            <button
              v-for="action in quick_actions"
              :key="action.title"
              v-can-create.permission="action.permission"
              class="home-filter-action"
              @click="handle_quick_action(action.action)"
            >
              <img :src="action.icon" :alt="action.title" class="home-filter-action-icon" />
              <span>
                <strong>{{ action.title }}</strong>
                <small>{{ action.description }}</small>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <StickyNav activeTab="normal_loans_info" />
</div>
